<div class="modal in hs-composition-delete-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{'COMMON.confirm' | translateHs }}
                </h4>
                <button type="button" (click)="close()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs ">
                </button>
            </div>
            <div class="modal-body" style="max-height: 600px; overflow-y: auto">
                <span>{{'COMPOSITIONS.dialogDelete.doYouWantToDeleteMap' | translateHs }}</span>
                {{data.compositionToDelete.title}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="delete(data.compositionToDelete)">{{'COMMON.ok' |
                    translateHs }}</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">{{'COMMON.close'
                    | translateHs }}</button>
            </div>
        </div>
    </div>
</div>